import React from 'react';

export interface DangerousHTMLProps {
  element: string,
  html: string,
  // eslint-disable-next-line react/require-default-props
  className?: string,
}

export const DangerousHTML: React.FC<DangerousHTMLProps> = (
  props,
) => {
  const {
    element,
    html,
    ...rest
  } = props;
  return React.createElement(element, {
    ...rest,
    dangerouslySetInnerHTML: {
      __html: html,
    },
  });
};
